import type { Field } from './types';

export const DEFAULT_OPTION_NAME = 'name';
export const DEFAULT_OPTION_ID = 'id';

export const ACTIVE_STATUS_FILTER: Field = {
    type: 'single-select',
    variation: 'chip',
    label: 'Active',
    name: 'is_active',
    placeholder: 'All',
    optionName: DEFAULT_OPTION_NAME,
    optionValue: DEFAULT_OPTION_ID,
    optionId: DEFAULT_OPTION_ID,
    options: [
        { id: '', name: 'All' },
        { id: 'true', name: 'Active' },
        { id: 'false', name: 'Inactive' },
    ],
    defaultValue: '',
};
